import { render } from "./editRoomOffline.vue?vue&type=template&id=2519ecbd&scoped=true"
import script from "./editRoomOffline.vue?vue&type=script&lang=js"
export * from "./editRoomOffline.vue?vue&type=script&lang=js"

import "./editRoomOffline.vue?vue&type=style&index=0&id=2519ecbd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2519ecbd"]])

export default __exports__